import { FilingTypeApiSetData } from '@api/filingTypes/types';
import { deleteRequest, getRequest, postRequest, putRequest } from '@helpers/api';

/**
 * Gets a list of available filing types
 */
export const getFilingPeriodList = (
  /** Limits results to a specific registration */
  entityJurisdictionId: string,
  /** The initial index from which to return the results. */
  offset?: number,
  /** Number of results to return per page. */
  limit = 200
): Promise<unknown> =>
  getRequest('vFlow/period/', { entity_jurisdiction: entityJurisdictionId, offset, limit });

/**
 * Gets a list of filing types for a registration
 */
export const getRegFilingTypesList = (
  /** Limits results to a specific registration */
  entityJurisdictionId: string,
  /** The initial index from which to return the results. */
  offset?: number,
  /** Number of results to return per page. */
  limit?: number
): Promise<unknown> =>
  getRequest('vFlow/registrationFilingType/', {
    entity_jurisdiction: entityJurisdictionId,
    offset,
    limit,
  });

/**
 * Delete a filing type from a registration
 */
export const deleteRegFilingType = (filingId: string): Promise<unknown> =>
  deleteRequest(`vFlow/registrationFilingType/${filingId}/`);

/**
 * Create a filing type for a registration
 */
export const createRegFilingType = (data: FilingTypeApiSetData): Promise<unknown> =>
  postRequest('vFlow/registrationFilingType/', data);

/**
 * Updates a filing type for a registration
 */
export const updateRegFilingType = (
  filingId: string,
  data: FilingTypeApiSetData
): Promise<unknown> => putRequest(`vFlow/registrationFilingType/${filingId}/`, data);
